/*
 * Copyright Huesik (c) 2019.
 */

// import Vuex from 'vuex'
import MapConstants from '../../const/maps'
import kosiwonApi from '../../api/kosiwons'
import EventBus from '../../core/modules/eventBus'

class CollagesAndSubwayOverlay {
  collagesAndSubway = []
  map = null
  daumInstance = null
  overlayList = []
  clickTargetZoom
  type
  store
  axios
  rangeObject

  static isOpened = false

  static getIsOpened () {
    return this.isOpened
  }

  constructor (type, collagesAndSubway, daumInstance, map, store, axios) {
    this.type = type
    this.collagesAndSubway = collagesAndSubway
    this.daumInstance = daumInstance
    this.map = map
    this.store = store
    this.axios = axios



    // this.clickTargetZoom = clickTargetZoom

    window.clickCollagesAndSubwayOverlay = async (lat, lng) => {
      const searchKosiwonList = await this.getSelectedRangeKosiwon(lat, lng)
      this.removeRangeObject()
      // this.store.dispatch('setMapCenter', {
      //   latitude: lat,
      //   longitude: lng
      // })
      EventBus.$emit('clearClickedMapObject')
      this.setRangeObject(lat, lng)
      this.store.dispatch('setSearchKosiwonList', searchKosiwonList)
      this.store.dispatch('setOpenStatus', 'small')
    }

    this.createOverlay()
  }

  async getSelectedRangeKosiwon (lat, lng) {
    const kosiwonList = await kosiwonApi.fetch({
      lat,
      lng,
      range: MapConstants.RANGE_SEARCH_DISTANCE,
      moneyRange: this.store.getters.getMoneyRange
    })
    return kosiwonList.data.result
  }

  setRangeObject (lat, lng) {
    this.rangeObject = new this.daumInstance.maps.Circle({
      map: this.map,
      center : new this.daumInstance.maps.LatLng(lat, lng),
      radius: MapConstants.RANGE_SEARCH_DISTANCE,
      strokeWeight: 2,
      strokeColor: '#3c6cbb',
      strokeOpacity: 0.5,
      // strokeStyle: 'dashed',
      fillColor: '#3c6cbb',
      fillOpacity: 0.1
    })

    this.rangeObject.setMap(this.map)
    CollagesAndSubwayOverlay.isOpened = true
  }

  removeRangeObject () {
    if (this.rangeObject) {
      this.rangeObject.setMap(null)
      this.rangeObject = null
      CollagesAndSubwayOverlay.isOpened = false
    }
  }

  createOverlay () {
    this.collagesAndSubway.map((item) => {

      const overlayElem = `<div class="collagesAndSubwayOverlay ${this.type}" onclick="clickCollagesAndSubwayOverlay(${item.lat}, ${item.lng})">
        <span>${item.name}</span>
      </div>`

      const customOverlay = new this.daumInstance.maps.CustomOverlay({
        // map: this.map,
        clickable: true,
        content: overlayElem,
        position: new this.daumInstance.maps.LatLng(item.lat, item.lng),
        xAnchor: 0.5,
        yAnchor: 1,
        zIndex: 3
      })

      this.overlayList.push(customOverlay)
    })

    return this.overlayList
  }

  setMap () {
    this.overlayList.map(overlay => {
      overlay.setMap(this.map)
    })
  }

  removeMap () {
    this.overlayList.map(overlay => {
      overlay.setMap(null)
    })
  }
}

export default CollagesAndSubwayOverlay
